export const LOG_COLLECTOR_IMAGE_TAG = "2.25.0";
export const LOG_COLLECTOR_IMAGE = `ghcr.io/akash-network/log-collector:${LOG_COLLECTOR_IMAGE_TAG}`;
